import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View } from 'react-native';
import { ProcessTypes, UserWorkoutSession } from 'fitbeat.gym-core';
import { Logger } from '../../utils/Logger';
import { cancelBookingConfirmed, getNextBookingStep, setWorkoutSession } from '../actions';
import { styles as sharedStyles } from './Styles';
import { ConfirmAction } from '../components';
import { GymResolver } from '../../services';
import { showToastMessage, bookingCanceledToast } from '../../ui';

export const cancelWorkoutBooking = async ({
  userProfile,
  workoutSession,
  workoutSessionService,
  setWorkoutSession,
  getNextBookingStep,
  cancelBookingConfirmed,
  showToastMessage,
  setIsLoading,
  clearError,
  setError
}) => {
  try {
    if (clearError) clearError();
    if (setIsLoading) setIsLoading(true);

    const workoutSessions = await workoutSessionService.cancelBooking(workoutSession.uniqueReference);
    showToastMessage(bookingCanceledToast(moment(workoutSession.startTimeOfFirstExercise).format('dddd, Do MMMM')));
    setWorkoutSession(null);
    cancelBookingConfirmed(workoutSessions, userProfile);
    getNextBookingStep(userProfile, ProcessTypes.BookingCancelled);
    
    return workoutSessions;
  } catch (error) {
    if (setError) setError(error);
    Logger.notify(error);
    throw error;
  } finally {
    if (setIsLoading) setIsLoading(false);
  }
};

class ConfirmCancelBooking extends Component {
  static getTitle = () => '';

  state = {
    isLoading: false,
  }

  setIsLoading = (isLoading) => {
    this.setState({ isLoading });
  }

  setError = (error) => {
    this.setState({ error });
  }

  clearError = () => {
    this.setError(null);
  }

  cancelBooking = async () => {
    const {
      userProfile,
      workoutSession,
      setWorkoutSession,
      getNextBookingStep,
      workoutSessionService,
      cancelBookingConfirmed,
    } = this.props;

    await cancelWorkoutBooking({
      userProfile,
      workoutSession,
      workoutSessionService,
      setWorkoutSession,
      getNextBookingStep,
      cancelBookingConfirmed,
      showToastMessage: this.props.showToastMessage,
      setIsLoading: this.setIsLoading,
      clearError: this.clearError,
      setError: this.setError
    });
  }

  dontCancelBooking = () => {
    const { userProfile, getNextBookingStep } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.Start);
  }

  render() {
    const { t, workoutSession } = this.props;
    const { isLoading, error } = this.state;

    if (!workoutSession) {
      return <></>;
    }

    let metaText;
    if ((UserWorkoutSession.hasPairedSession(workoutSession) && UserWorkoutSession.isWorkoutSessionConfirmed(workoutSession.pairedSession))
      || UserWorkoutSession.isHomeGroupBooking(workoutSession, GymResolver.getByName)) {
      metaText = t('cancelInviteConfirmationPairText');
    }

    return (
      <View style={sharedStyles.containerNoPadding}>
        <ConfirmAction
         title={t('deleteWorkout')}
         subtitle={t('deleteWorkoutConfirmationText')}
          metaText={metaText}
          leftButtonText={t('yesDeleteWorkout')}
          rightButtonText={t('no')}
          leftButtonPress={this.cancelBooking}
          rightButtonPress={this.dontCancelBooking}
          isLoading={isLoading}
          error={error}
          leftButtonOverrideStyles={sharedStyles.leftButtonOverideStyle}
          rightButtonOverrideStyles={sharedStyles.rightButtonOverideStyle}
        />
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workoutSession: state.bookings.bookingWizard.workoutSession,
    bookingWizard: state.bookings.bookingWizard,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    showToastMessage: (toast) => dispatch(showToastMessage(toast)),
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
    setWorkoutSession: (booking) => dispatch(setWorkoutSession(booking)),
    cancelBookingConfirmed: (workoutSessions, userProfile) => dispatch(cancelBookingConfirmed(workoutSessions, userProfile)),
  };
};

ConfirmCancelBooking = connect(mapStateToProps, mapDispatchToProps)(ConfirmCancelBooking);
export default translate(['bookings'], { wait: true })(ConfirmCancelBooking);
